import React, { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../button';
import { ButtonGroup, Label } from './styles';
import { ButtonVariant } from '../../../button/types';
import { Tabs } from '../beam-required-axis-table';

interface TabButtonGroupProps {
  tabSelected: Tabs;
  setTabSelected: Dispatch<SetStateAction<Tabs>>;
}

const TabButtonGroup = ({ tabSelected, setTabSelected }: TabButtonGroupProps) => {
  const { t } = useTranslation();

  const buttonVariant = (tabId: number) => {
     return tabSelected === tabId ? ButtonVariant.tabSelected : ButtonVariant.tab;
  };

  return (
    <div>
      <Label>
        {t('concrete.structuralElements.disclaimer.Beam.chooseBeamType')}
      </Label>
      <ButtonGroup>
        <Button
          content={t(
            'concrete.structuralElements.disclaimer.Beam.SimpleSupported.label'
          )}
          onClick={() => setTabSelected(Tabs.SimpleBeam)}
          variant={buttonVariant(Tabs.SimpleBeam)}
        />
        <Button
          content={t(
            'concrete.structuralElements.disclaimer.Beam.Continuous.label'
          )}
          onClick={() => setTabSelected(Tabs.ContinuousBeam)}
          variant={buttonVariant(Tabs.ContinuousBeam)}
        />
      </ButtonGroup>
    </div>
  );
};

export default TabButtonGroup;
